module.exports = __webpack_public_path__ + "fonts/fa-brands-400.6402aa0.woff2";